import { getAuth } from 'firebase/auth'
import { app } from 'app/providers/FirebaseProvider/ui/FirebaseProvider'
import { BackendApiError } from './minecardsBackendClient'
import { createIdempotencyKey } from './createIdempotencyKey'

const request = async (path, options = {}) => {
    const user = getAuth(app).currentUser
    const headers = { Accept: 'application/json', ...options.headers }
    if (user?.getIdToken) {
        headers.Authorization = `Bearer ${await user.getIdToken()}`
    }
    const response = await fetch(`/api/v1${path}`, {
        ...options,
        credentials: 'include',
        headers,
    })
    const payload = await response.json().catch(() => null)
    if (!response.ok) {
        throw new BackendApiError(
            payload?.error?.message ||
                `Admin request failed (${response.status})`,
            { status: response.status, code: payload?.error?.code }
        )
    }
    return payload
}

export const fetchPendingAdminSuggestions = async () =>
    request('/admin/suggestions')

export const reviewAdminSuggestion = async (suggestionId, review) =>
    request(`/admin/suggestions/${suggestionId}/review`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Idempotency-Key': createIdempotencyKey('admin-review'),
        },
        body: JSON.stringify(review),
    })

export const searchAdminUsers = async (query) =>
    request(`/admin/users?query=${encodeURIComponent(query)}`)

export const fetchAdministrators = async () => request('/admin/users/admins')

export const fetchAdminHistory = async ({ kind = 'all', beforeId } = {}) => {
    const params = new URLSearchParams({ kind, limit: '30' })
    if (beforeId) params.set('beforeId', String(beforeId))
    return request(`/admin/history?${params.toString()}`)
}

export const updateAdminAccess = async (userId, patch) =>
    request(`/admin/users/${userId}/access`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'Idempotency-Key': createIdempotencyKey('admin-access'),
        },
        body: JSON.stringify(patch),
    })
